import { render, staticRenderFns } from "./SolicitacaoManutencaoView.vue?vue&type=template&id=3a838c49&"
import script from "./SolicitacaoManutencaoView.vue?vue&type=script&lang=ts&"
export * from "./SolicitacaoManutencaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports